module.exports = __webpack_public_path__ + "static/img/lw.39923b47.png";